import React from "react";

const TabsControls = ({
  isGroupAdmin,
  currentTab,
  setCurrentTab,
  myFacePhotos,
  media,
  sortBy,
  setSortBy,
}) => {
  return (
    <div className="controls-section">
      {isGroupAdmin ? (
        <nav className="tabs-nav">
          <button
            className={`tab ${currentTab !== "all" ? "active" : ""}`}
            onClick={() => setCurrentTab("my")}
            aria-pressed={currentTab !== "all"}
          >
            My Photos ({myFacePhotos.length})
          </button>
          <button
            className={`tab ${currentTab === "all" ? "active" : ""}`}
            onClick={() => setCurrentTab("all")}
            aria-pressed={currentTab === "all"}
          >
            All Photos ({media.length})
          </button>
        </nav>
      ) : (
        <div className="non-admin-title">
          <span className="my-photos-badge">
            My Photos ({myFacePhotos.length})
          </span>
        </div>
      )}

      <div className="controls-right">
        <select
          className="sort-select"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <option value="latest">Latest First</option>
          <option value="oldest">Oldest First</option>
          <option value="name">Name A-Z</option>
        </select>
      </div>
    </div>
  );
};

export default TabsControls;
